import { PageIntro } from '@/workspace/ui';

/* Page heading — the prototype's page heading: eyebrow, title, optional description, actions on the right. */
export const PageHeader = ({ title, description, children }) => <PageIntro title={title} description={description} actions={children} />;
